export const blockIconsActivitiesBackpackNew = (
	<span className='material-symbols-outlined'>backpack</span>
);
